import { createContext, useContext } from 'react'

type DisclosureContextState = {
  floating: boolean
  isOpen: boolean
  toggleIsOpen: () => void
}

export const DisclosureContext = createContext<DisclosureContextState | null>(
  null,
)

export const useDisclosureContext = () => {
  const context = useContext(DisclosureContext)
  if (!context) {
    throw new Error(
      'useDisclosureContext must be used within the DisclosureContext.Provider',
    )
  }
  return context
}
